import store from "../store";
import ru from "../i18n/ru.js";
import en from "../i18n/en.js";

const locales = {
  "ru-RU": ru,
  "en-US": en
};

export default function i18nFilter(key) {
  const locale = store.getters.user.locale || "ru-RU";
  let str = locales[locale][key];
  if (str === null || str === undefined) str = `[I18n_Error]: ${key} not found`;
  return str;
}
